module.exports = __webpack_public_path__ + "img/ic-transferwise.712dec29.svg";